module.exports = __webpack_public_path__ + "img/ic_open_link.8ff44bd6.svg";